import { Controller } from "@hotwired/stimulus";
import { loadFilePond } from "../models/filepond_loader";

export default class NftController extends Controller {
  static targets = ["buyNowSection", "timedAuctionSection", "radio", "buyNowButton", "timedAuctionButton"];

  connect() {
    const selectMethod = this.element.dataset.selectMethod;
    if (selectMethod) {
      this.change();
    }
  }

  changeSubmitButton(e) {
    const link = this.element.querySelector(".create_nft");
    if (e.target.checked) {
      link.classList.remove("disabled");
    } else {
      link.classList.add("disabled");
    }
  }

  changeNftButton(e) {
    const listNftBtn = this.element.querySelector(".list-nft-btn");
    if (e.target.checked) {
      listNftBtn.classList.remove("disabled");
    } else {
      listNftBtn.classList.add("disabled");
    }
  }

  async selectFile(e) {
    e.preventDefault();
    const FilePond = await loadFilePond();
    let filePound = FilePond.find(($(e.currentTarget).closest(".nft_form").find(".nft_image")[0]));
    if (filePound.getFiles().length > 0) {
      filePound.removeFiles();
    }
    filePound.browse();
  }

  change() {
    const selected = this.radioTargets.find(r => r.checked)?.value;
    this.buyNowSectionTarget.classList.toggle("d-none", selected !== "buy_now");
    this.timedAuctionSectionTarget.classList.toggle("d-none", selected !== "timed_auction");
    this.buyNowButtonTarget.classList.toggle("active", selected === "buy_now");
    this.timedAuctionButtonTarget.classList.toggle("active", selected === "timed_auction");
  }

}
